/**
 * Text baked into the digital hero pixel grid (watermark-style).
 * Edit lines here to change what the mosaic spells out.
 */
export const DIGITAL_BACKDROP_BRAND = {
  headline: 'MYCARSLOT',
  tagline: 'HONEST CARS · STRAIGHT DEALS',
  hint: 'BUY · SELL · FINANCE · TRADE',
};
